import { ReactNode } from 'react'
import styled from 'styled-components'

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e4e6e7;
  line-height: 1.3;
`

interface CellProps {
  align?: 'left' | 'center' | 'right'
  width?: string | number
}

interface HeaderProps extends CellProps {
  offset?: string | number
}

export const Header = styled.th<HeaderProps>`
  text-align: ${({ align = 'left' }) => align};
  font-size: 16px;
  position: sticky;
  top: ${({ offset = 0 }) => offset};
  padding: 16px 8px;
  background: white;
  width: ${({ width = 'auto' }) => width};
  z-index: 2;
  color: #4f4f4f;
  font-weight: 600;

  &:first-child {
    padding-left: 16px;
  }

  &:last-child {
    padding-right: 16px;
  }

  &::after {
    content: '';
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 0;
    left: 0;
    background: #e4e6e7;
  }
`

export const Cell = styled.td<CellProps>`
  text-align: ${({ align = 'left' }) => align};
  border-bottom: 1px solid #e4e6e7;
  padding: 16px 8px;
  font-size: 16px;

  &:first-child {
    padding-left: 16px;
  }

  &:last-child {
    padding-right: 16px;
  }
`

interface EmptyRowProps {
  children: ReactNode
}

export const EmptyRow = ({ children }: EmptyRowProps) => (
  <tr>
    <Cell colSpan={99} align="center">
      {children}
    </Cell>
  </tr>
)
